import React, { useEffect, useRef, useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { attachmentBase, attachmentClient } from "@/lib/invoiceAttachments";

export const AttachmentImage = ({ invoiceId, file, viewer, page = 0, thumbnail = false, testId }) => {
  const root = useRef(null);
  const [visible, setVisible] = useState(!thumbnail);
  const [state, setState] = useState({ url: "", error: false });
  useEffect(() => {
    if (!thumbnail || !root.current) return;
    const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { setVisible(true); observer.disconnect(); } }, { rootMargin: "150px" });
    observer.observe(root.current); return () => observer.disconnect();
  }, [thumbnail]);
  useEffect(() => {
    if (!visible) return;
    const controller = new AbortController(); let url;
    setState({ url: "", error: false });
    attachmentClient(viewer).get(`${attachmentBase(invoiceId, viewer)}/${file.id}/preview`, { params: { mode: thumbnail ? "thumb" : "page", page }, responseType: "blob", signal: controller.signal })
      .then(({ data }) => { if (!controller.signal.aborted) { url = URL.createObjectURL(data); setState({ url, error: false }); } })
      .catch(() => { if (!controller.signal.aborted) setState({ url: "", error: true }); });
    return () => { controller.abort(); if (url) URL.revokeObjectURL(url); };
  }, [invoiceId, file.id, viewer, page, thumbnail, visible]);
  return <div ref={root} className={thumbnail ? "flex h-full w-full items-center justify-center overflow-hidden bg-white" : "flex min-h-48 w-full items-center justify-center"} data-testid={testId}>
    {state.url ? <img src={state.url} alt={thumbnail ? `${file.name} preview` : `${file.name}, page ${page + 1}`} className={thumbnail ? "h-full w-full object-contain" : "h-auto max-h-none w-full object-contain"} data-testid={`${testId}-image`} />
      : state.error ? <div className="flex flex-col items-center gap-2 p-3 text-center text-muted-foreground"><FileText className="h-8 w-8" />{!thumbnail && <p className="text-sm" data-testid={`${testId}-error`}>This page couldn’t be previewed. You can download the original.</p>}</div>
      : <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />}
  </div>;
};